import React from "react";
import { HttpStatusCode } from "axios";

import { logout } from "../../services/authServices";

import SimplePopup from "../../components/Popup/Simple";

type Props = {};

export type OpenOptions = {
  onClick?: () => void;
  title?: string;
  unUseHorizonRule?: boolean;
  icon?: string;
  buttonText?: string;
  enableDimmedClose?: boolean;
};

export default function useSimplePopup(props: Props): [
  React.ReactNode,
  {
    open: (message: string, option?: OpenOptions) => void;
    openError: (e: any, message: string, option?: OpenOptions) => void;
    close: () => void;
  }
] {
  const [popup, setPopup] = React.useState<"failed" | "">("");
  const [errorMessage, setErrorMessage] = React.useState<string>("");
  const [option, setOption] = React.useState<OpenOptions>({});

  return [
    <SimplePopup
      isOpen={popup === "failed"}
      message={errorMessage}
      onClose={() => {
        setPopup("");
      }}
      {...option}
    />,
    {
      open: (message: string, options?: OpenOptions) => {
        setErrorMessage(message);
        setPopup("failed");
        if (options) {
          setOption(options);
        } else {
          setOption({});
        }
      },
      openError: (e: any, message: string, options?: OpenOptions) => {
        if (e?.response?.status === HttpStatusCode.Unauthorized) {
          logout();
          return;
        } else if (e?.response?.data?.error) {
          setErrorMessage(e?.response?.data?.error?.replace(". ", ".\n"));
        } else if (e?.message) {
          setErrorMessage(e?.message);
        } else {
          setErrorMessage(message);
        }

        setPopup("failed");

        if (options) {
          setOption(options);
        } else {
          setOption({});
        }
      },
      close: () => {
        setPopup("");
      },
    },
  ];
}
